import axios from "axios";
import { authHeaderJson, authHeaderJsonIntegrationFG } from "../auth-header.service";

const getVisorintegrationreportdata = (id) => {
    return axios.get(`/api/integration/get/visorintegrationreportdata/`, { headers: authHeaderJson() } );
};

const getIntegrationconfig = (id) => {
    return axios.get(`/api/integration/get/integrationconfig/${id}`, { headers: authHeaderJson() } );
};

const getIntegrationreport = (id) => {
    return axios.get(`/api/integration/get/integrationreport/${id}`, { headers: authHeaderJson() } );
};

const getIntegrationdictionarykpi = (id) => {
    return axios.get(`/api/integration/get/integrationdictionarykpi/${id}`, { headers: authHeaderJson() } );
};

const getAllIntegrationconfig = () => {
    return axios.get(`/api/integration/list/integrationconfig`, { headers: authHeaderJson() } );
};

const getAllIntegrationreport = () => {    
    return axios.get(`/api/integration/list/integrationreport`, { headers: authHeaderJson() } );
};

const getAllIntegrationdictionarykpi = () => {    
    return axios.get(`/api/integration/list/integrationdictionarykpi`, { headers: authHeaderJson() } );
};


const getDailyIntegrationReport = () => {    
    return axios.get(`/api/integration/list/dailyreport`, { headers: authHeaderJson() } );
};


const addIntegrationconfigList = (items) => {    
    return axios.post(`/api/integration/add/list/integrationconfig`, items, { headers: authHeaderJson() } );
}

const addIntegrationreportList = (items) => {
    return axios.post(`/api/integration/add/list/integrationreport`, items, { headers: authHeaderJson() } );
}

const addIntegrationdictionarykpiList = (items) => {
    return axios.post(`/api/integration/add/list/integrationdictionarykpi`, items, { headers: authHeaderJson() } );
}

const addIntegrationconfig= (item) => {
    return axios.post(`/api/integration/add/integrationconfig`, item, { headers: authHeaderJson() } );
}

const addIntegrationreport= (item) => {
    return axios.post(`/api/integration/add/integrationreport`, item, { headers: authHeaderJson() } );
}

const addIntegrationdictionarykpi= (item) => {
    return axios.post(`/api/integration/add/integrationdictionarykpi`, item, { headers: authHeaderJson() } );
}

const saveIntegrationConfig = (id, item) => {    
    return axios.put(`/api/integration/update/integrationconfig/${id}`, item, { headers: authHeaderJson() });
};

const saveIntegrationreport = (id, item) => {    
    return axios.put(`/api/integration/update/integrationreport/${id}`, item, { headers: authHeaderJsonIntegrationFG() });
};

const saveIntegrationdictionarykpi= (id, item) => {
    return axios.put(`/api/integration/update/integrationdictionarykpi/${id}`, item, { headers: authHeaderJson() });
};

const deleteIntegrationconfig= (id) => {
    return axios.delete(`/api/integration/delete/integrationconfig/${id}`, { headers: authHeaderJson() });
}

const deleteIntegrationreport= (id) => {
    return axios.delete(`/api/integration/delete/integrationreport/${id}`, { headers: authHeaderJson() });
}

const deleteIntegrationdictionarykpi= (id) => {
    return axios.delete(`/api/integration/delete/integrationdictionarykpi/${id}`, { headers: authHeaderJson() });
}

export {
    getVisorintegrationreportdata,
    getIntegrationconfig,
    getIntegrationreport,
    getIntegrationdictionarykpi,
    getAllIntegrationconfig,
    getAllIntegrationreport,
    getAllIntegrationdictionarykpi,
    getDailyIntegrationReport,
    addIntegrationconfig,
    addIntegrationreport,
    addIntegrationdictionarykpi,
    saveIntegrationConfig,
    saveIntegrationreport,
    saveIntegrationdictionarykpi,
    addIntegrationconfigList,
    addIntegrationreportList,
    addIntegrationdictionarykpiList,
    deleteIntegrationconfig,
    deleteIntegrationreport,
    deleteIntegrationdictionarykpi
}